import { render, staticRenderFns } from "./InvoiceArrivedView.vue?vue&type=template&id=2c39ddd8&scoped=true&"
import script from "./InvoiceArrivedView.vue?vue&type=script&lang=js&"
export * from "./InvoiceArrivedView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceArrivedView.vue?vue&type=style&index=0&id=2c39ddd8&lang=scss&scoped=true&"
import style1 from "./InvoiceArrivedView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39ddd8",
  null
  
)

export default component.exports